export default __webpack_public_path__ + "static/media/360.17d5a8e6.svg";